import { useQuery } from "@tanstack/react-query";

import {
  DocumentByIdDTO,
  DocumentsDTO,
  DocumentsQuery,
  ScopePopup,
  getDocumentBills,
  getDocumentById,
  getDocumentScope,
  getDocumentSupplieById,
  getDocuments,
  getUseUserSettings,
} from "api";

import { QUERY_KEYS } from "consts";

import { useState } from "react";
import { DOCUMENTS_REFETCH_INTERVAL } from "./consts";
import { OptionalRefetchIntervalAndRetry } from "./types";

export const useDocuments: any = ({
  refetchInterval = DOCUMENTS_REFETCH_INTERVAL,
  retry = false,
  ...query
}: DocumentsQuery & OptionalRefetchIntervalAndRetry) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState(true);
  const { data, error, refetch } = useQuery<DocumentsDTO>(
    [QUERY_KEYS.DOCUMENTS, query],
    async () => {
      setIsLoading(true)
      try {
        const result = await getDocuments(query);
        setIsLoading(false);
        return result;
        // eslint-disable-next-line @typescript-eslint/no-shadow
      } catch (error) {
        setIsLoading(false);
        throw error;
      }
    },
    {
      refetchInterval,
      retry,
      onSuccess: () => setIsLoading(false),
      onError: () => setIsLoading(false),
    },
  );
  return { data, isLoading, error, refetch };
};

export const useDocumentScope = ({
  refetchInterval = DOCUMENTS_REFETCH_INTERVAL,
  retry = false,
  ...query
}: DocumentsQuery & OptionalRefetchIntervalAndRetry) =>
  useQuery<any>([QUERY_KEYS.DOCUMENTS, query], () => getDocumentScope(query), {
    refetchInterval,
    retry,
  });

export const useUserSettings = () =>
  useQuery<any>([QUERY_KEYS.USER_SETTING], () => getUseUserSettings());

export const useDocumentById = (id: string) =>
  useQuery<DocumentByIdDTO>([QUERY_KEYS.DOCUMENTS, id], () =>
    getDocumentById(id),
  );

export const useDocumentSuppliesById = (id: string) =>
  useQuery<ScopePopup[]>([QUERY_KEYS.DOCUMENTS, id], () =>
    getDocumentSupplieById(id),
  );

export const useDocumentBills = (id: string) =>
  useQuery<any>([QUERY_KEYS.DOCUMENT_BILLS, id], () => getDocumentBills(id));

export const useApprovalDataById = (id: string) =>
  useQuery<ScopePopup[]>([QUERY_KEYS.APPROVAL, id], () =>
    getDocumentSupplieById(id),
  );
